import { AppSelectBox } from 'components';
import useESClass from 'hooks/API/GET/useESClass';
import { Fragment } from 'react';

function ESClassDropDown({
  enableAPI,
  value,
  handleChange,
  dependencies = {},
  fieldErrors = {},
  labelClass,
  defaultLook = true,
  label = 'Select class',
}) {
  const { query = '' } = dependencies;
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;

  const { data, isLoading, isError } = useESClass({ enabled: enableAPI, queryParams });

  return (
    <AppSelectBox
      labelProps={{ label, className: labelClass }}
      selectProps={{
        value,
        onChange: (event) => {
          const obj = data?.data?.find?.((item) => item._id === event.target.value);
          if (obj && obj.value) obj._id = obj.value;

          handleChange(event, obj);
        },
      }}
      fieldErrors={fieldErrors}
      options={data?.data?.map((option) => {
        return {
          label: option.name,
          value: option._id,
        };
      })}
      onChangeEvent={(args) => {
        if (args.value)
          handleChange({ target: { value: args.value } }, { ...args, _id: args.value });
      }}
      defaultLook={defaultLook}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

ESClassDropDown.defaultProps = {
  handleChange: () => {},
};

export default ESClassDropDown;
